var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.313,
    height: 17.164,
    viewBox: "0 0 19.313 17.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "edit",
    d: "M13.5,2.886l3.024,3.024a.328.328,0,0,1,0,.463L9.2,13.7l-3.112.345a.652.652,0,0,1-.721-.721l.345-3.112,7.323-7.323a.328.328,0,0,1,.463,0Zm5.432-.768L17.295.482a1.311,1.311,0,0,0-1.851,0L14.257,1.669a.328.328,0,0,0,0,.463l3.024,3.024a.328.328,0,0,0,.463,0l1.187-1.187A1.311,1.311,0,0,0,18.931,2.119ZM12.876,11.7v3.413H2.146V4.388H9.851a.412.412,0,0,0,.285-.117L11.477,2.93a.4.4,0,0,0-.285-.687H1.609A1.61,1.61,0,0,0,0,3.852v11.8a1.61,1.61,0,0,0,1.609,1.609h11.8a1.61,1.61,0,0,0,1.609-1.609V10.364a.4.4,0,0,0-.687-.285L12.993,11.42A.412.412,0,0,0,12.876,11.7Z",
    transform: "translate(0 -0.1)",
    fill: "#9aa5b1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.b471cb7100c7f0d9520d1ad087800250.svg";
export { ForwardRef as ReactComponent };